import { isApiError } from "../api/errors";

/** True when an error is an optimistic-concurrency conflict (412 / VERSION_CONFLICT). */
export function isVersionConflict(e: unknown): boolean {
  return isApiError(e) && (e.status === 412 || e.code === "VERSION_CONFLICT");
}
